// Vendors
import { POSITIONS, SnackbarMessageType } from '@openbank/ziniaweb-ui-components';
import { FeatureFlagsLendingOnboardingEnumeration } from '@gruposantander/opbpay-ui-core-models';

const SESSION_EXPIRES_SNACKBAR_PROPS = {
    closeTimeout: 5,
    closeIcon: { icon: 'icon_symbols_close-thick' },
    popover: {
      focusFirstDescendantAutomatically: false,
      trapFocusInsideModal: false,
    },
    variant: 'SIMPLE',
    icon: {
      icon: 'icon_symbols_information-in-a-circle',
    },
    maxWidth: '400px',
    type: SnackbarMessageType.WARNING,
    align: POSITIONS.BOTTOM_CENTER_FIXED as any,
  },
  SESSION_EXPIRE_FF_PROPS = {
    id: FeatureFlagsLendingOnboardingEnumeration.SESSION_TIMEOUT_CONTROLLER,
  };

export { SESSION_EXPIRE_FF_PROPS, SESSION_EXPIRES_SNACKBAR_PROPS };
